import { useDispatch } from "react-redux";
import { openSnackbar } from "../dux/snackbar";
import { snackBarStatus } from "../helpers/constants";

/**
 * Custom hook for handling snackbar notifications
 * @returns {Object} Object containing showSuccess, showError, and showInfo methods
 */
export const useSnackbar = () => {
  const dispatch = useDispatch();

  const showSuccess = (message) => {
    dispatch(
      openSnackbar({
        message,
        status: snackBarStatus.SUCCESS,
      })
    );
  };

  const showError = (message) => {
    dispatch(
      openSnackbar({
        message,
        status: snackBarStatus.ERROR,
      })
    );
  };

  const showInfo = (message) => {
    dispatch(
      openSnackbar({
        message,
        status: snackBarStatus.SUCCESS, // Using SUCCESS for info since there's no INFO status
      })
    );
  };

  return {
    showSuccess,
    showError,
    showInfo,
  };
};
